<nz-form-item>
    <nz-form-control nzErrorTip="Please input your username!">
        <nz-input-group class="!w-full">
            @switch (item.type) {
            @case ('select'){
                <nz-form-label [nzFor]="item.key">{{item.label}}</nz-form-label>
                @if(item.options){
                    <nz-select nzShowSearch nzAllowClear class="w-full" [formControl]="fc" [nzPlaceHolder]="item.label ?? ''">
                        <nz-option *ngFor="let option of item.options" [nzLabel]="option.label"
                            [nzValue]="option.key"></nz-option>
                    </nz-select>
                }
                @else if(optionList) {
                    <nz-select nzShowSearch nzAllowClear class="w-full" [formControl]="fc" [nzPlaceHolder]="item.label ?? ''" (nzOpenChange)="onOpenChange($event)" (nzScrollToBottom)="onScrollToBottom()">
                        @if (!loading) {
                            @for (o of optionList; track o) {
                              <nz-option [nzLabel]="o.label"
                                  [nzValue]="o.key"></nz-option>
                            }
                          } @else {
                            <nz-option nzDisabled nzCustomContent>
                              Loading Data...
                            </nz-option>
                          }
                          @if (loadingMore) {
                            <nz-option nzDisabled nzCustomContent>
                              Loading more...
                            </nz-option>
                          }
                    </nz-select>

                }

            }
            @case ('date') {
            <nz-form-label [nzFor]="item.key">{{item.label}}</nz-form-label>
            <div>
                <nz-date-picker [formControl]="fc" [nzPlaceHolder]="item.label ?? ''"></nz-date-picker>
            </div>
            }
            @case('date-range') {
            <nz-form-label [nzFor]="item.key">{{item.label}}</nz-form-label>
            <div>
                <nz-range-picker [formControl]="fc" class="w-full"></nz-range-picker>
            </div>

            }
            @case('switch') {
            <nz-form-label [nzFor]="item.key">{{item.label}}</nz-form-label>
            <div>
                <nz-switch [formControl]="fc"></nz-switch>
            </div>
            }
            @default{
            <nz-form-label [nzFor]="item.key">{{item.label}}</nz-form-label>
            <input [formControl]="fc" nz-input [placeholder]="item.label" />
            }
            }
        </nz-input-group>
    </nz-form-control>
</nz-form-item>